// Source of truth for PRODUCTION's Cognito/API Gateway values.
//
// Not imported directly by app code - `select-config.sh production` (run
// automatically by `npm run build:production`) copies this file's contents
// into aws-config.js, the file the app actually imports. Editing
// aws-config.js by hand instead of editing this file is how staging and
// production values got mixed up in the past (see CLAUDE.md's dashboard
// CORS/"failed to fetch" entries) - always edit the per-environment file,
// never aws-config.js directly.
//
// Regenerate these values from the production stack's own outputs if they
// ever change:
//
//   AWS_PROFILE=innovation-prod aws cloudformation describe-stacks \
//     --stack-name instapay-router-callback-dashboard-production \
//     --query "Stacks[0].Outputs"
//
export const awsConfig = {
  region: 'ap-southeast-1',
  userPoolId: 'ap-southeast-1_2xd234wlQ',
  userPoolClientId: '32j859pigmbcbcu73s4012b92a',
  apiBaseUrl: 'https://elw0hlvok4.execute-api.ap-southeast-1.amazonaws.com/production',
};
